import * as ent from '../entities/index'
import * as enums from '../enums/index'

export class SecurityUtil  {
    constructor() 
    { 
        
    }
  
    public static CanAccessFeature(userInfo: ent.UserInfo, featureID: number) : boolean {
        var val: boolean = false;
        if (userInfo != null && userInfo.Features != null)
        {
            if (userInfo.Features.filter(x=>x.ID == featureID).length > 0)
            {
                val = true;
            }
        }

        return val;
    }

    public static IsSalesOfficeRequestTypeEnabled(userInfo: ent.UserInfo, requestTypeId: number, 
            salesOfficeRequestTypes: ent.SalesOfficeRequestType[] ) : boolean {
        var val: boolean = false;
    
    
        if (userInfo != null && userInfo.SalesOffice != null)
        {
            if (salesOfficeRequestTypes.filter(x=>x.RequestTypeID == requestTypeId && x.IsEnabled).length > 0)
            {
                val = true;
            }
        }

        return val;
    }

    public static ShowSaveButton(request: ent.Request, userInfo: ent.UserInfo): boolean {
        
        // if (!request){
        //     return false;
        // }
        return true;
    }

    public static ShowSubmitButton(request: ent.Request, userInfo: ent.UserInfo): boolean {
        
        if (!request){
            return false;
        }
        if (this.HasEquipmentRequiringApproval(request)){
            return true;
        }

        if (SecurityUtil.SubmitUsingAPI(request.RequestType)){
            return true;
        }

        
        return  (request.RequestTypeID == enums.RequestTypeEnum.VisitPlanUpdate && SecurityUtil.CanAccessFeature(userInfo, enums.Feature.SubmitVisitPlanUpdates ))
            ||
                (request.RequestTypeID == enums.RequestTypeEnum.ZRPartnerUpdate && SecurityUtil.CanAccessFeature(userInfo, enums.Feature.SubmitZRPartnerUpdates ))
            ||
                (request.RequestTypeID == enums.RequestTypeEnum.FullServicePricing && request.FullServicePricingInfo.NeedsReview == true);

    }
    
    public static DisableSubmitButton(request: ent.Request): boolean {
        return !(request.ID > 0) || request.RequestStatusID != enums.RequestStatusEnum.Open;
    }

    public static DisableSaveButton(request: ent.Request): boolean {
        if (request == undefined) { return false;}
        return request.RequestStatusID == enums.RequestStatusEnum.InProgress || request.RequestStatusID == enums.RequestStatusEnum.Completed;
    }

    public static ShowCompleteButton(request: ent.Request, userInfo: ent.UserInfo): boolean {
        
        
        if (!request){
            return false;
        }

        switch (request.RequestTypeID){
            case enums.RequestTypeEnum.VisitPlanUpdate:
                return SecurityUtil.CanAccessFeature(userInfo, enums.Feature.CompleteVisitPlanUpdates);
            case enums.RequestTypeEnum.ZRPartnerUpdate:
                return SecurityUtil.CanAccessFeature(userInfo, enums.Feature.CompleteZRPartnerUpdates);
            case enums.RequestTypeEnum.FullServicePricing:
                return SecurityUtil.CanAccessFeature(userInfo, enums.Feature.ReviewFullServicePricingUpdates) 
                    && request.RequestStatusID == enums.RequestStatusEnum.InProgress;
            default:
                if (!SecurityUtil.CanAccessFeature(userInfo, enums.Feature.PerformRequestWorkflow)){
                    return false;
                }    
                return request.RequestStatusID == enums.RequestStatusEnum.InProgress || request.RequestStatusID == enums.RequestStatusEnum.PendingEquipmentInstall
        }
    }

    public static ShowRejectButton(request: ent.Request, userInfo: ent.UserInfo): boolean {
        
        
        if (!request){
            return false;
        }

        if (this.HasEquipmentRequiringApproval(request) && request.RequestStatusID == enums.RequestStatusEnum.Submitted
                && request.SalesOfficeApprovers.some(x=>x.EmployeeID == userInfo.Employee.ID 
                    && x.Inactive === false    
                    && x.ApprovalTypeID == enums.ApprovalType.ModelApproval)){
            return true;
        }
        
        var val: boolean = false;
        switch (request.RequestTypeID) 
        { 
            case enums.RequestTypeEnum.VisitPlanUpdate: 
                val = SecurityUtil.CanAccessFeature(userInfo, enums.Feature.CompleteVisitPlanUpdates) &&
                    (request.RequestStatusID == enums.RequestStatusEnum.Submitted || request.RequestStatusID == enums.RequestStatusEnum.Open || request.RequestStatusID == enums.RequestStatusEnum.InProgress);
                return val;
            case enums.RequestTypeEnum.ZRPartnerUpdate: 
                val = SecurityUtil.CanAccessFeature(userInfo, enums.Feature.CompleteZRPartnerUpdates) &&
                    (request.RequestStatusID == enums.RequestStatusEnum.Submitted || request.RequestStatusID == enums.RequestStatusEnum.Open) || request.RequestStatusID == enums.RequestStatusEnum.InProgress;
                return val;
            case enums.RequestTypeEnum.FullServicePricing: 
                val = request.FullServicePricingInfo.NeedsReview == true 
                        && request.RequestStatusID == enums.RequestStatusEnum.Submitted
                        && SecurityUtil.CanAccessFeature(userInfo, enums.Feature.ReviewFullServicePricingUpdates)
                return val;
            default:
                val = SecurityUtil.CanAccessFeature(userInfo, enums.Feature.PerformRequestWorkflow);
                break;     
        }

        if (val == true){
            switch (request.RequestStatusID){
                case enums.RequestStatusEnum.Completed:
                case enums.RequestStatusEnum.Emailed:
                case enums.RequestStatusEnum.InProgress:
                case enums.RequestStatusEnum.PendingEquipmentInstall:
                    val = true;
                    break;
            }
        }
        return val;
    }

    public static ShowInProgressButton(request: ent.Request, userInfo: ent.UserInfo): boolean {

        if (!request){
            return false;
        }

        switch (request.RequestTypeID){
            case enums.RequestTypeEnum.VisitPlanUpdate:
            case enums.RequestTypeEnum.ZRPartnerUpdate:
                return false;
            case enums.RequestTypeEnum.FullServicePricing:
                return  request.RequestStatusID == enums.RequestStatusEnum.Emailed 
                    && SecurityUtil.CanAccessFeature(userInfo, enums.Feature.ReviewFullServicePricingUpdates);
            default:
                return  request.RequestStatusID == enums.RequestStatusEnum.Emailed
                    && SecurityUtil.CanAccessFeature(userInfo, enums.Feature.PerformRequestWorkflow);
        }

    }

    public static ShowDeleteButton(request: ent.Request, userInfo: ent.UserInfo): boolean {

        if (!request){
            return false;
        }

        switch (request.RequestStatusID){
            case enums.RequestStatusEnum.Open:
                return true;
            default:
                return false;
        }

    }

    public static ShowCompletionDetails(request: ent.Request, userInfo: ent.UserInfo): boolean {
        
        if (!request){
            return false;
        }

        if (!SecurityUtil.CanAccessFeature(userInfo, enums.Feature.PerformRequestWorkflow)){
            return false;
        }

        if (request.RequestType.CompletionNumberTypeID == enums.CompletionNumberTypeEnum.None){
            return false;
        }

        switch (request.RequestStatusID)
        {
            case enums.RequestStatusEnum.InProgress:
            case enums.RequestStatusEnum.Completed:
            case enums.RequestStatusEnum.PendingEquipmentInstall:
                return true;
        }
        return false;
    }

    public static ShowBatchDetails(request: ent.Request, userInfo: ent.UserInfo): boolean {
        
        if (!request){
            return false;
        }

        if (!SecurityUtil.CanAccessFeature(userInfo, enums.Feature.PerformRequestWorkflow)){
            return false;
        }

        if (request.BatchID && request.BatchID > 0){
            return true;
        }

        return false;
    }

    public static ShowApproveButton(request: ent.Request, userInfo: ent.UserInfo): boolean {
        
        
        if (!request){
            return false;
        }

        if (this.HasEquipmentRequiringApproval(request) && request.RequestStatusID == enums.RequestStatusEnum.Submitted
                && request.SalesOfficeApprovers.some(x=>x.EmployeeID == userInfo.Employee.ID 
                    && x.Inactive === false
                    && x.ApprovalTypeID == enums.ApprovalType.ModelApproval)){
            return true;
        }


        return  (request.RequestTypeID == enums.RequestTypeEnum.FullServicePricing 
            && request.FullServicePricingInfo.NeedsReview == true 
            && request.RequestStatusID == enums.RequestStatusEnum.Submitted
            && SecurityUtil.CanAccessFeature(userInfo, enums.Feature.ReviewFullServicePricingUpdates));
    }

    public static ShowBatchExportButton(request: ent.Request, userInfo: ent.UserInfo): boolean {
        
        
        if (!request){
            return false;
        }

        if (!SecurityUtil.CanAccessFeature(userInfo, enums.Feature.PerformRequestWorkflow)){
            return false;
        }

        var val: boolean = false;
        switch (request.RequestStatusID) 
        { 
            case enums.RequestStatusEnum.Open: 
            case enums.RequestStatusEnum.Emailed: 
            case enums.RequestStatusEnum.InProgress: 
                val = request.RequestType.HasRequestTypeFiles && SecurityUtil.CanAccessFeature(userInfo, enums.Feature.BatchExport);
                break;     
            default:
                break;
        }
        return val;
    }

    public static showBatchInfo(userInfo: ent.UserInfo): boolean {
        return  SecurityUtil.CanAccessFeature(userInfo, enums.Feature.BatchExport);
    }
    
    public static DisableCompleteButton(request: ent.Request): boolean {
        if (request.ID <= 0) {
            return true
        }
        switch (request.RequestTypeID){
            case enums.RequestTypeEnum.FullServicePricing:
                return request.RequestStatusID != enums.RequestStatusEnum.InProgress;
            case enums.RequestTypeEnum.ZRPartnerUpdate:
            case enums.RequestTypeEnum.VisitPlanUpdate:
                return request.RequestStatusID != enums.RequestStatusEnum.Submitted && request.RequestStatusID != enums.RequestStatusEnum.InProgress;
            default:
                return request.RequestStatusID != enums.RequestStatusEnum.InProgress && request.RequestStatusID != enums.RequestStatusEnum.PendingEquipmentInstall;
        }
    }

    public static DisableRejectButton(request: ent.Request): boolean {
        if (request.ID <= 0) {
            return true
        }
        if (request.RequestTypeID == enums.RequestTypeEnum.FullServicePricing && request.RequestStatusID != enums.RequestStatusEnum.Submitted)
        {
            return true;
        }
        return false;
    }
    
    public static ShowEmailButton(request: ent.Request) : boolean {
        if (request == undefined){
            return false;
        }
        
        if (request.ID <= 0){
            return false;
        }

        if (this.HasEquipmentRequiringApproval(request)){
            return false;
        }

        if (this.SubmitUsingAPI(request.RequestType)){
            return false;
        }
        switch (request.RequestTypeID){
            case enums.RequestTypeEnum.VisitPlanUpdate:
            case enums.RequestTypeEnum.ZRPartnerUpdate:    
                return false;
            case enums.RequestTypeEnum.FullServicePricing:
                return request.FullServicePricingInfo.NeedsReview == false;
            default:
                return request.RequestStatusID != enums.RequestStatusEnum.InProgress && request.RequestStatusID != enums.RequestStatusEnum.Completed
                    && request.RequestStatusID != enums.RequestStatusEnum.Emailed;
        }
    }

    public static HasEquipmentRequiringApproval(request: ent.Request) : boolean {
        if (request.VendorLineItems && request.VendorLineItems.length > 0 && request.VendorInfo.Model.RequireApproval === true) {
            return true;
        }
        if (request.FountainLineItems && request.FountainLineItems.length > 0) {
            if (request.FountainLineItems.some(x=>x.Model.RequireApproval === true)) {
                return true;
            }
        }
        if (request.CoolerLineItems && request.CoolerLineItems.length > 0) {
            if (request.CoolerLineItems.some(x=>x.Model.RequireApproval === true)) {
                return true;
            }
        }
        return false;
    }

    public static SubmitUsingAPI(rt: ent.RequestType) : boolean {
        return rt.SubmitUsingAPI && rt.APIActive;
    }
}